module.exports = __webpack_public_path__ + "static/img/device-s4.031133bb.png";